export const GET_EXPENSE_WORKFLOW_STATUSES = 'GET_EXPENSE_WORKFLOW_STATUSES'
export const GET_EXPENSE_WORKFLOW_STATUSES_FAILED = 'GET_EXPENSE_WORKFLOW_STATUSES_FAILED'
export const GET_EXPENSE_WORKFLOW_STATUSES_SUCCEEDED = 'GET_EXPENSE_WORKFLOW_STATUSES_SUCCEEDED'
